// extracted by mini-css-extract-plugin
export var layoutContainer = "_5k-0";
export var layoutContainerNoRounding = "_5k-6";
export var layoutContainerOpen = "_5k-5";
export var layoutContainerResizing = "_5k-1";
export var mainContent = "_5k-2";
export var resizeDivider = "_5k-3";
export var slidePanel = "_5k-4";